'use client';

import LocaleSwitcher from '@/components/ui/local-switcher';
import { useLocale } from 'next-intl';
import LinksList from './links-list';
import Alerts from './alerts';
import { sortJSONKeys } from '@/utils/global';

const TopHeader = ({ alerts, topLinks, welcomeMessage }) => {
  const locale = useLocale();

  const sortedTopLinks = sortJSONKeys(Array.isArray(topLinks?.value) ? topLinks.value : []);
  const sortedAlerts = sortJSONKeys(Array.isArray(alerts?.value) ? alerts.value : []);

  return (
    <header className='bg-[#F6F6F7] px-2 py-2 max-lg:hidden sm:px-3 md:px-4 lg:px-10'>
      <div className='flex items-center justify-between py-0'>
        <LinksList data={sortedTopLinks} locale={locale} />
        <Alerts data={sortedAlerts} locale={locale} />
        <div className='flex items-center gap-5'>
          {welcomeMessage?.[`message-${locale}`] && (
            <p className='border-e pe-5 text-xs'>
              {welcomeMessage[`message-${locale}`]}
            </p>
          )}
          <LocaleSwitcher />
        </div>
      </div>
    </header>
  );
};

export default TopHeader;
